<template>
    <app-layout>
        <div class="text-center my-5 py-5">
            <h1 class="display-3 mb-5">Ooops!!!</h1>
            <p class="h4 mb-5">Not implemented yet.</p>
            <div class="h2">:(</div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
export default {
    name: "NotImplemented",
    components: {AppLayout}
}
</script>

<style scoped>

</style>
